const STORAGE_KEY = "cookie_consent";

export interface CookiePreferences {
  analytics: boolean;
  marketing: boolean;
  accepted: boolean;
  timestamp?: string;
}

const DEFAULT_PREFS: CookiePreferences = {
  analytics: false,
  marketing: false,
  accepted: false,
};

export const getConsent = (): CookiePreferences => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return JSON.parse(stored);
  } catch {
    // ignore
  }
  return { ...DEFAULT_PREFS };
};

export const setConsent = (prefs: Omit<CookiePreferences, "timestamp">) => {
  const full: CookiePreferences = {
    ...prefs,
    accepted: true,
    timestamp: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(full));
  return full;
};

export const hasConsented = (): boolean => {
  return getConsent().accepted;
};

export const resetConsent = () => {
  localStorage.removeItem(STORAGE_KEY);
};
